import { Box } from "@mui/material";
import React from "react";
import "./providers.section.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { ProviderSelector } from "./provider.selector";
import { useAppSelector } from "../../store/hooks/store.hooks";
import { useNavigate } from "react-router-dom";
export const ProvidersSection = () => {
  const { providers } = useAppSelector(ProviderSelector("main"));
  const navigator = useNavigate();
  return (
    <Box className="providers-section">
      {providers.length > 0 && (
        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={"auto"}
          className="providers-section__swiper"
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          speed={2000}
          style={{ transitionTimingFunction: "linear" }}
        >
          {providers &&
            providers.map((provider) => {
              return (
                <SwiperSlide
                  className="providers-section__slide-item"
                  key={`providers-sections_${provider.id}`}
                >
                  <Box
                    className="providers-section__item"
                    onClick={() => {
                      if (provider.id === 27 || provider.id === 38) {
                        navigator(`/lobby/live?provider=${provider.id}`);
                        return;
                      }
                      navigator(`/lobby/slots?provider=${provider.id}`);
                    }}
                  >
                    <img
                      className="providers-section__image"
                      src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/providers/${provider.image}`}
                      alt={provider.image}
                    />
                  </Box>
                </SwiperSlide>
              );
            })}
        </Swiper>
      )}
    </Box>
  );
};
